"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm.868-2.432c-.35.333-.641.432-.868.432-.227 0-.518-.1-.868-.432-.354-.337-.719-.872-1.047-1.61-.561-1.263-.958-2.991-1.06-4.958h5.95c-.102 1.966-.499 3.695-1.06 4.958-.328.738-.693 1.273-1.047 1.61zM14.974 11H9.026c.101-1.967.498-3.695 1.06-4.958.327-.738.692-1.273 1.046-1.61.35-.333.641-.432.868-.432.227 0 .518.1.868.432.354.337.719.872 1.047 1.61.561 1.263.958 2.991 1.06 4.958zm2.003 2h2.961a8.006 8.006 0 01-4.384 6.169c.065-.13.128-.263.188-.399.69-1.552 1.132-3.566 1.235-5.77zm2.961-2h-2.961c-.103-2.204-.545-4.218-1.235-5.77a9.78 9.78 0 00-.188-.399A8.006 8.006 0 0119.938 11zM7.023 11H4.062a8.007 8.007 0 014.384-6.169c-.065.13-.128.263-.188.399-.69 1.552-1.132 3.566-1.235 5.77zm-2.961 2h2.961c.103 2.204.545 4.218 1.235 5.77.06.136.123.269.188.399A8.006 8.006 0 014.062 13z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;